import React from "react";
import {Modal} from "antd";

import ModalRow from "./ModalRow";
import CloseIcon from "./CloseIcon";


function HowToPlayModal(props) {
	return (
		<Modal
			closeIcon={<CloseIcon />}
			visible={props.visible}
			onCancel={props.onCancel}
			footer={null}
			centered
			width={500}
		>
			<ModalRow title="How to Play" />
			<ModalRow
				prefix={<img style={{height: 30}} alt="Goal" src="https://res.cloudinary.com/drsmugc99/image/upload/v1752725712/how-to-1_eqautf.svg" />}
				heading="- The Goal -"
				body="Figure out how two movie stars are connected through their films."
			/>
			<ModalRow
				prefix={<img style={{height: 24}} alt="Goal" src="https://res.cloudinary.com/drsmugc99/image/upload/v1752725712/how-to-2_cwoptm.svg" />}
				heading="- Expand your board -"
				body="Build new connections by typing the names of movies & stars connected to the ones already in your board."
			/>
			<ModalRow
				prefix={<img style={{height: 27}} alt="Goal" src="https://res.cloudinary.com/drsmugc99/image/upload/v1752725713/how-to-3_oyl0bj.svg" />}
				heading="- Connect the Stars -"
				body="Challenge yourself to find the shortest path!"
			/>
		</Modal>
	);
}

export default HowToPlayModal;
